import React from 'react';
import { getBrandingAssetUrl } from '@/utils/runtimeApi';

const loginImageUrl = getBrandingAssetUrl('login-image');

export const AuthLayout = ({ title, subtitle, children, footer }) => {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(14,116,144,0.14),_transparent_35%),linear-gradient(135deg,#f7fafc_0%,#eef6ff_45%,#fff8ef_100%)]">
      <div className="mx-auto flex min-h-screen max-w-7xl flex-col lg:flex-row">
        <div className="relative hidden flex-1 overflow-hidden lg:flex">
          <img src={loginImageUrl} alt="Uçar Motor" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-slate-950/35" />
          <div className="absolute bottom-10 left-10 max-w-lg text-white">
            <p className="mb-3 text-xs uppercase tracking-[0.35em] text-white/80">Uçar Motor</p>
            <h1 className="text-4xl font-semibold leading-tight">Ekip erişimini tek merkezden güvenli şekilde yönetin.</h1>
            <p className="mt-4 text-sm text-white/80">Email & şifre ile giriş, kayıt ve güvenli şifre sıfırlama akışları.</p>
          </div>
        </div>

        <div className="flex flex-1 items-center justify-center p-4 sm:p-8 lg:p-12">
          <div className="w-full max-w-md rounded-[28px] border border-slate-200/70 bg-white/95 p-6 shadow-[0_24px_80px_rgba(15,23,42,0.10)] backdrop-blur sm:p-8">
            <div className="mb-8">
              <div className="mb-5 lg:hidden">
                <img src={loginImageUrl} alt="Uçar Motor" className="h-36 w-full rounded-2xl object-contain" />
              </div>
              <h1 className="text-4xl font-semibold tracking-tight text-slate-900">{title}</h1>
              <p className="mt-3 text-sm text-slate-600">{subtitle}</p>
            </div>
            {children}
            {footer ? <div className="mt-6 border-t pt-5 text-sm text-slate-600">{footer}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};